export class ImageStackUrlResolver {
  private readonly _urlResolver: (uriGuid: string) => Promise<string>;

  public constructor(urlResolver: (uriGuid: string) => Promise<string>) {
    this._urlResolver = urlResolver;
  }

  public async resolveAsync(id: string, isReduced: boolean): Promise<{ headerUrl: string; dataUrl: string }> {
    const type = isReduced ? '.lq' : '.hq';
    return {
      headerUrl: await this._urlResolver(id + type + '.ihdr'),
      dataUrl: await this._urlResolver(id + type + '.hevc')
    };
  }
}
